import { defineStore } from "pinia";
import type { TaskNotification } from "~/api/task_notification/interfaces";

export const useNotificationsStore = defineStore("notifications", {
  state: () => ({
    unreadCount: 0,
  }),
  actions: {
    async fetchUnreadCount(options?: {
      showToast?: boolean;
      toastMessage?: string;
      toastParams?: Record<string, unknown>;
      userId?: number;
    }) {
      // If userId is provided, filter by user, otherwise get all (for admin view)
      let url = "/task_notification/?limit=999";
      if (options?.userId) {
        url += `&recipient_id=${options.userId}`;
      }

      const { fetchWrapper } = await import("~/api/fetchWrapper");
      const response = await fetchWrapper.get(
        url,
        undefined,
        undefined,
        undefined,
        options,
      );
      const notifications = (response?._data as { results: TaskNotification[] })
        .results;

      this.unreadCount = notifications.filter((n) => !n.solved).length;
    },
    decrementUnread() {
      if (this.unreadCount > 0) this.unreadCount--;
    },
  },
});
